/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newAppStoryProductSchema = z
	.object({
		id: z.uuid(),
		name: z.string(),
		price: z.number().nullable().describe("Минимальная цена блюда на точке (с акцией, если она есть)."),
		image_link: z.string().nullable(),
	})
	.describe("Блюдо истории — по данным точки гостя.");
